/*
 * @Date: 2022-07-14 11:05:35
 * @Author: 王溪
 * @LastEditTime: 2022-12-07 17:17:34
 * @description: 
 * @FilePath: \pcweb-share\src\main.js
 * @LastEditors: 王溪
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import element from './plugins/element-ui'
import {Cookies} from './utils/Cookies'
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n';
// import i18n from '../src/i18n/i18n.js';
import { Message } from 'element-ui'
import store from '../src/store/index';
import './assets/icon/iconfont.css';
import './style/base.less';
import './assets/icon/iconfont.js';
import "lib-flexible/flexible";
import "@/plugins/vant";  //引入按需引入的vant
import common from '@/utils/utils'
 import '@/utils/transformCode.js';
import VueLazyload from 'vue-lazyload';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import touch from 'vue-directive-touch';
Vue.use(touch)


Vue.use(element)
Vue.use(VueI18n);
Vue.use(Vuex);
Vue.use(VueLazyload);
Vue.use(elTableInfiniteScroll);



Vue.config.productionTip = false
// 把变量挂载到vue的原型上
Vue.prototype.$message = Message
Vue.prototype.$utils = common
Vue.prototype.$Cookies = Cookies


import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

if(process.env.NODE_ENV == 'test'){
  const VConsole = require("vconsole");
  new VConsole();
}





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js